import { FOfferType, NonEmptyArray } from '../../../../../../../../../packages/JsonQuery';
import { useSelector } from 'react-redux';
import { selectObjectTypeFilter } from 'shared/selectors/advancedFilters';
import { useOfferTypeChangeHandler } from 'shared/hooks';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { FC, useCallback } from 'react';

export const RentLongObjectTypeContainer: FC = () => {
  const { value, options } = useSelector(selectObjectTypeFilter);

  const onOfferTypeChange = useOfferTypeChangeHandler();

  const handleObjectTypeChange = useCallback(
    (nextValue: NonEmptyArray<FOfferType> | null) => {
      onOfferTypeChange(nextValue ?? /* istanbul ignore next */ []);
    },
    [onOfferTypeChange],
  );

  return (
    <AdvancedFilterRow label="Тип объекта">
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleObjectTypeChange} />
    </AdvancedFilterRow>
  );
};
